import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "digitstypeoptions"
    }}>{`DigitsTypeOptions`}</h1>
    <p>{`Digits type options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DEFAULT_DIGITS`}</strong>{` = 1684628581`}</p>
      <p parentName="blockquote">{`Default digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ARABIC_DIGITS`}</strong>{` = 1684627826`}</p>
      <p parentName="blockquote">{`Arabic digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HINDI_DIGITS`}</strong>{` = 1684629609`}</p>
      <p parentName="blockquote">{`Hindi digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FARSI_DIGITS`}</strong>{` = 1684629089`}</p>
      <p parentName="blockquote">{`Farsi digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NATIVE_DIGITS`}</strong>{` = 1684631137`}</p>
      <p parentName="blockquote">{`native digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FULL_FARSI_DIGITS`}</strong>{` = 1684629094`}</p>
      <p parentName="blockquote">{`Full Farsi digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`THAI_DIGITS`}</strong>{` = 1684632680`}</p>
      <p parentName="blockquote">{`Thai digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LAO_DIGITS`}</strong>{` = 1684630625`}</p>
      <p parentName="blockquote">{`Lao digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DEVANAGARI_DIGITS`}</strong>{` = 1684628598`}</p>
      <p parentName="blockquote">{`Devanagari digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BENGALI_DIGITS`}</strong>{` = 1684628069`}</p>
      <p parentName="blockquote">{`Bengali digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GURMUKHI_DIGITS`}</strong>{` = 1684629357`}</p>
      <p parentName="blockquote">{`Gurmukhi digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GUJARATI_DIGITS`}</strong>{` = 1684629354`}</p>
      <p parentName="blockquote">{`Gujarati digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ORIYA_DIGITS`}</strong>{` = 1684631410`}</p>
      <p parentName="blockquote">{`Oriya digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TAMIL_DIGITS`}</strong>{` = 1684632673`}</p>
      <p parentName="blockquote">{`Tamil digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TELUGU_DIGITS`}</strong>{` = 1684632677`}</p>
      <p parentName="blockquote">{`Telugu digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KANNADA_DIGITS`}</strong>{` = 1684630369`}</p>
      <p parentName="blockquote">{`Kannada digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MALAYALAM_DIGITS`}</strong>{` = 1684630881`}</p>
      <p parentName="blockquote">{`Malayalam digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TIBETAN_DIGITS`}</strong>{` = 1684632681`}</p>
      <p parentName="blockquote">{`Tibetan digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KHMER_DIGITS`}</strong>{` = 1684630376`}</p>
      <p parentName="blockquote">{`Khmer digits`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BURMESE_DIGITS`}</strong>{` = 1684628085`}</p>
      <p parentName="blockquote">{`Burmese digits`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      